import { PERMISSIONS } from '@core/constants/permissions.constants';
import { ReportConfig } from './sparepart-report.config';

export const EQUIPMENT_SERVICEABILITY_REPORT_CONFIG: ReportConfig = {
  id: 'equipment-serviceability',
  title: 'Equipment Serviceability Report',
  permissions: {
    view: PERMISSIONS.GSE.REPORTS.EQUIPMENT_SERVICEABILITY.VIEW,
    export: PERMISSIONS.GSE.REPORTS.EQUIPMENT_SERVICEABILITY.EXPORT,
  },
  filters: [
    {
      type: 'text',
      field: 'search',
      label: 'Search',
      placeholder: 'Search'
    },
    {
      type: 'dropdown',
      field: 'equipment',
      label: 'Equipment',
      placeholder: 'Equipment'
    },
    {
      type: 'dropdown',
      field: 'equipmentCategory',
      label: 'Category',
      placeholder: 'Category'
    },
    {
      type: 'dropdown',
      field: 'equipmentType',
      label: 'Type',
      placeholder: 'Type'
    },
    {
      type: 'dropdown',
      field: 'equipmentModel',
      label: 'Model',
      placeholder: 'Model'
    },
    {
      type: 'dropdown',
      field: 'equipmentServiceability',
      label: 'Serviceability',
      placeholder: 'Serviceability'
    }
  ],

  columns: [
    {
      field: 'equipmentName',
      header: 'Equipment Name',
      type: 'text',
      width: '22%',
    },
    {
      field: 'category',
      header: 'Category',
      type: 'text',
      width: '14%',
    },
    {
      field: 'equipmentType',
      header: 'Type',
      type: 'text',
      pipes: ['replaceUnderscore', 'titlecase'],
      width: '12%',
    },
    {
      field: 'model',
      header: 'Model',
      type: 'text',
      width: '12%',
    },
    {
      field: 'equipmentId',
      header: 'ID Number',
      type: 'text',
      width: '12%',
    },
    {
      field: 'serviceability',
      header: 'Serviceability',
      type: 'text',
      pipes: ['replaceUnderscore', 'titlecase', 'formatServiceability'],
      width: '28%',
    },
  ],
};
